import { render, staticRenderFns } from "./UsersVrioForm.vue?vue&type=template&id=66bd06d9&"
import script from "./UsersVrioForm.vue?vue&type=script&lang=js&"
export * from "./UsersVrioForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports